(function () {
  if (window.nbBoostSwatchLoaded) return;
  window.nbBoostSwatchLoaded = true;

  const CACHE_KEY = 'nb_swatch_v12_'; 
  const DEBOUNCE_DELAY = 150;
  let debounceTimer;
  const activeFetches = new Set(); 

  const swatchObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const handle = entry.target.getAttribute('data-product-handle');
        observer.unobserve(entry.target); 
        processSwatchFetch(handle);
      }
    });
  }, { rootMargin: '250px 0px' }); 

  const runFetcher = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const wrappers = document.querySelectorAll('.boost-js-swatch-wrapper:not(.loaded):not(.observing)');
      wrappers.forEach(w => {
        w.classList.add('observing');
        swatchObserver.observe(w);
      });
    }, DEBOUNCE_DELAY);
  };

  const bindSwatchEvents = (swatchBlock, productCard) => {
    swatchBlock.addEventListener('click', (e) => e.stopPropagation());

    const swatches = swatchBlock.querySelectorAll('tooltip-component');
    
    // Detect if the device has a mouse (Desktop) or is a touchscreen (Mobile)
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    
    swatches.forEach(swatch => {
      const newImgSrc = swatch.getAttribute('data-sibling-image');
      const newLink = swatch.getAttribute('data-sibling-link');
      const innerLink = swatch.querySelector('.sibling__link');

      const triggerImageSwap = () => {
        if (newImgSrc) {
          const pictureSources = productCard.querySelectorAll('.boost-sd__product-link-image source');
          pictureSources.forEach(source => source.srcset = newImgSrc);

          const mainImgs = productCard.querySelectorAll('.boost-sd__product-image-img, .product-item__image img');
          mainImgs.forEach(img => {
            img.src = newImgSrc;
            img.srcset = newImgSrc; 
          });
        }

        if (newLink) {
          const links = productCard.querySelectorAll('a.boost-sd__product-link, a.product-link');
          links.forEach(link => link.href = newLink);
        }

        swatchBlock.querySelectorAll('.sibling__link').forEach(el => el.classList.remove('sibling__link--current'));
        if (innerLink) innerLink.classList.add('sibling__link--current');
      };

      if (isDesktop) {
        // DESKTOP LOGIC: Hover to swap, Click to navigate
        swatch.addEventListener('mouseenter', () => {
          triggerImageSwap();
        });

        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation(); 
          if (newLink) window.location.href = newLink; 
        });
      } else {
        // MOBILE LOGIC: Tap to swap. Tap again to navigate.
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation(); 
          
          const isActive = innerLink && innerLink.classList.contains('sibling__link--current');
          
          if (isActive) {
            // If it's already the active swatch, go to the PDP
            if (newLink) window.location.href = newLink;
          } else {
            // Otherwise, just swap the image and update the main card's link
            triggerImageSwap();
          }
        });
      }
    });
  };

  const replaceSwatchNode = (handle, htmlSnippet) => {
    if (!htmlSnippet || htmlSnippet.trim() === '') return;
    
    requestAnimationFrame(() => {
      const targets = document.querySelectorAll(`.boost-js-swatch-wrapper:not(.loaded)[data-product-handle="${handle}"]`);
      
      targets.forEach(target => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlSnippet;
        const newBlock = tempDiv.firstElementChild;
        
        if (newBlock) {
          newBlock.classList.add('loaded', 'boost-js-swatch-wrapper');
          newBlock.setAttribute('data-product-handle', handle);
          newBlock.style.position = 'relative';
          newBlock.style.zIndex = '20';
          
          const productCard = target.closest('.boost-sd__product-item');
          target.replaceWith(newBlock);
          
          if (productCard) bindSwatchEvents(newBlock, productCard);
        }
      });
    });
  };

  const hideBrokenSwatches = handle => {
    requestAnimationFrame(() => {
      const brokenSwatches = document.querySelectorAll(`.boost-js-swatch-wrapper:not(.loaded)[data-product-handle="${handle}"]`);
      brokenSwatches.forEach(ws => ws.style.display = 'none');
    });
  };

  const processSwatchFetch = (handle) => {
    if (!handle) return;
    
    const cached = window.sessionStorage.getItem(`${CACHE_KEY}${handle}`);
    if (cached) {
      if (cached === '404') hideBrokenSwatches(handle);
      else replaceSwatchNode(handle, cached);
      return;
    }

    if (activeFetches.has(handle)) return; 
    activeFetches.add(handle);

    fetch(`/products/${handle}?view=swatch-data`)
      .then(res => {
        if (!res.ok) {
          hideBrokenSwatches(handle);
          return null;
        }
        return res.text();
      })
      .then(html => {
        if (!html) return;
        try { window.sessionStorage.setItem(`${CACHE_KEY}${handle}`, html); } catch (e) {}
        replaceSwatchNode(handle, html);
      })
      .catch(() => {})
      .finally(() => {
        activeFetches.delete(handle);
      });
  };

  document.addEventListener('boost-sd:product-list-render', runFetcher);
  document.addEventListener('boost-sd:filter-render', runFetcher);
  if (window.BoostPFS) { document.addEventListener('boost-pfs-filter-after-render', runFetcher); }

  const observer = new MutationObserver(mutations => {
    let shouldRun = false;
    for (const m of mutations) {
      if (m.addedNodes.length > 0) { shouldRun = true; break; }
    }
    if (shouldRun) runFetcher();
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(runFetcher, 100);
})();